module.exports = __webpack_public_path__ + "img/mobile.4519efba.png";